<template>
  <div class="column is-half domain-tip">
    <p class="is-size-4 has-text-weight-bold is-uppercase">
      {{ title }}
    </p>
    <p class="is-medium">
      {{ tip }}
    </p>
  </div>
</template>

<script>
export default {

  name: 'DomainTip',
  props: {
    title: {
      type: String,
      default: ''
    },
    tip: {
      type: String,
      default: ''
    }
  },
  data () {
    return {

    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../sass/_variables.scss';
.domain-tip {
  padding: 20px;
  color: var(--primary-color)
}
</style>
